import { MutationTree } from 'vuex';
import { SearchState } from '../../models';
import { ClearSearchMutation } from './mutations/clear-search.mutation';
import { IncreasePageMutation } from './mutations/increase-page.mutation';
import { SaveSearchResponseMutation } from './mutations/save-search-response.mutation';
import { SetFacetCollapseMutation } from './mutations/set-facet-collapse.mutation';
import { SetFacetsFromPreselectedFiltersMutation } from './mutations/set-facets-from-preselected-filters.mutation';
import { SetFacetsGroupsMutation } from './mutations/set-facets-groups.mutation';
import { SetFacetsPanelCollapsedMutation } from './mutations/set-facets-panel-collapsed.mutation';
import { SetFacetsMutation } from './mutations/set-facets.mutation';
import { SetKeepPreviousResults } from './mutations/set-keep-previous-results.mutation';
import { SetLoadingMutation } from './mutations/set-loading.mutation';
import { SetPageMutation } from './mutations/set-page.mutation';
import { SetPreSelectedFilters } from './mutations/set-pre-selected.filters';
import { SetQueryMutation } from './mutations/set-query.mutation';
import { SetSortMutation } from './mutations/set-sort.mutation';
import { ToggleFilterMutation } from './mutations/toggle-filter.mutation';
import { UpdateFilterValueMutation } from './mutations/update-filter-value.mutation';
import { UpdateResultMutation } from './mutations/update-result.mutation';

export const SEARCH_MUTATIONS: MutationTree<SearchState> = {
  ...new ClearSearchMutation().mutations,
  ...new IncreasePageMutation().mutations,
  ...new SaveSearchResponseMutation().mutations,
  ...new SetFacetsMutation().mutations,
  ...new SetKeepPreviousResults().mutations,
  ...new SetLoadingMutation().mutations,
  ...new SetPageMutation().mutations,
  ...new SetPreSelectedFilters().mutations,
  ...new SetQueryMutation().mutations,
  ...new SetSortMutation().mutations,
  ...new SetFacetCollapseMutation().mutations,
  ...new ToggleFilterMutation().mutations,
  ...new SetFacetsPanelCollapsedMutation().mutations,
  ...new SetFacetsGroupsMutation().mutations,
  ...new UpdateResultMutation().mutations,
  ...new UpdateFilterValueMutation().mutations,
  ...new SetFacetsFromPreselectedFiltersMutation().mutations
};
